import type { QueryParams } from '../core/AbstractConnector';

export default function appendQueryParams(url: string, params?: QueryParams): string {
	if (!params) return url;

	const hasProtocol = url.startsWith('http://') || url.startsWith('https://');
	const u = new URL(url, hasProtocol ? undefined : 'http://local');

	for (const [key, value] of Object.entries(params)) {
		if (value === undefined || value === null) continue;

		if (Array.isArray(value)) {
			u.searchParams.delete(key);
			for (const v of value) {
				u.searchParams.append(key, String(v));
			}
			continue;
		}

		u.searchParams.set(key, String(value));
	}

	if (hasProtocol) return u.toString();
	return u.pathname + u.search;
}
